import React, { useEffect, useState } from 'react'
import TestimonialBg from "../../../../assets/images/testimonial-bg.jpg"
import User1 from "../../../../assets/images/testimonial-1.jpg"
import User2 from "../../../../assets/images/testimonial-2.jpg"

import Slider from 'react-slick'
import { axiosInstance, config } from '../../config'

const ClientReviews = () => {


    const [Loading, setLoading] = useState(false);
    const [Reviews, setReviews] = useState([]);

    useEffect(() => {
        getReviews()
    }, [])

    function getReviews() {
        setLoading(true)
        axiosInstance.get(`/get-reviews`)
            .then(res => {
                setReviews(res?.data?.reviews?.filter(item => Number(item.status) === 0).reverse())
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }


    // Infinite loop clones slides to fill empty slots, repeating a review.
    // Loop and autoplay only when there are more reviews than slots at that
    // screen size.
    const loopFor = (slots) => Reviews.length > slots;

    const settings = {
        dots: false,
        fade: false,
        infinite: loopFor(3),
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        waitForAnimate: false,
        arrows: false,
        autoplay: loopFor(3),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: loopFor(2),
                    autoplay: loopFor(2),
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: loopFor(2),
                    autoplay: loopFor(2),
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: loopFor(1),
                    autoplay: loopFor(1)
                }
            }
        ]
    };


    return (
        <div>
            <section className="testimonial-section">
                <div className="bg-layer" style={{ backgroundImage: `url(${TestimonialBg})` }}></div>
                <div className="auto-container">
                    <div className="row clearfix">

                        <div className="col-lg-12 col-md-12 col-sm-12 testimonial-column">
                            <div className="testimonial-content">
                                <div className="sec-title light text-center">
                                    <h2 className='mb-4 '>What our customers Say!</h2>
                                </div>
                                <div >
                                    <Slider {...settings} >
                                        {Reviews.length > 0 && Reviews.map((item, i) => (
                                            <div className="testimonial-block px-2" key={item.id}>
                                                <div className="testimonil-block-one">
                                                    <div className="inner-box">
                                                        <div className="border-box"></div>
                                                        <div className="bg-shape"></div>
                                                        <ul className="rating clearfix">
                                                            {Array(5)
                                                                .fill(0)
                                                                .map((_, index) => (
                                                                    <li key={index}>
                                                                        {index < item.rating ? (
                                                                            <i className="bi bi-star-fill"></i> // Filled star
                                                                        ) : (
                                                                            <i className="bi bi-star"></i> // Empty star
                                                                        )}
                                                                    </li>
                                                                ))}
                                                            {/* <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li>
                                                            <li><i className="bi bi-star-fill"></i></li> */}
                                                        </ul>
                                                        <h4>{item?.title}</h4>
                                                        <p>{item.description}</p>
                                                        <div className="author-box">
                                                            <figure className="author-thumb"><img src={item?.user?.image ? `${config.imageUrl}${item?.user?.image}` : User1} alt="" /></figure>
                                                            <h4>{item?.user?.name}</h4>
                                                            {/* <h6>California</h6> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {/* <div className="testimonial-block px-2">
                                            <div className="testimonil-block-one">
                                                <div className="inner-box">
                                                    <div className="border-box"></div>
                                                    <div className="bg-shape"></div>
                                                    <ul className="rating clearfix">
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                    </ul>
                                                    <h4>Great Experience with <br />udrive Team.</h4>
                                                    <p>I could not imagine a driving school look like udrive. It is state of art facility with rich contents and outstanding trainers. It was fun learning &amp; I enjoyed the whole experience.</p>
                                                    <div className="author-box">
                                                        <figure className="author-thumb"><img src={User2} alt="" /></figure>
                                                        <h4>Mia Isabella</h4>
                                                        <h6>Newyork</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonial-block px-2">
                                            <div className="testimonil-block-one">
                                                <div className="inner-box">
                                                    <div className="border-box"></div>
                                                    <div className="bg-shape"></div>
                                                    <ul className="rating clearfix">
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                        <li><i className="bi bi-star-fill"></i></li>
                                                    </ul>
                                                    <h4>Great Experience with <br />udrive Team.</h4>
                                                    <p>I could not imagine a driving school look like udrive. It is state of art facility with rich contents and outstanding trainers. It was fun learning &amp; I enjoyed the whole experience.</p>
                                                    <div className="author-box">
                                                        <figure className="author-thumb"><img src={User2} alt="" /></figure>
                                                        <h4>Mia Isabella</h4>
                                                        <h6>Newyork</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ClientReviews
